// replace the user pool region, id, and app client id details
export default {
  REGION: "ap-southeast-2",
  USER_POOL_ID: "ap-southeast-2_m0ddvgurH",
  USER_POOL_APP_CLIENT_ID: "2mcddm1k2vvpptc4m9phk3gja3",
};
